import React from 'react';

// Modern 3D Icon Component Generator
const Icon3D = ({ children, size = 24, gradient1 = '#FFD700', gradient2 = '#FF9800', gradient3 = '#E65100' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id={`grad-${gradient1.replace('#','')}`} x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor={gradient1} />
        <stop offset="50%" stopColor={gradient2} />
        <stop offset="100%" stopColor={gradient3} />
      </linearGradient>
      <filter id="shadow3d">
        <feDropShadow dx="1" dy="2" stdDeviation="2" floodColor="#000" floodOpacity="0.3"/>
      </filter>
      <linearGradient id="shine" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#FFF" stopOpacity="0.6" />
        <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
      </linearGradient>
    </defs>
    {children}
  </svg>
);

// 📊 Dashboard Icon - Modern Chart
export const DashboardIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="dashGrad1" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="#10B981" />
        <stop offset="100%" stopColor="#34D399" />
      </linearGradient>
      <linearGradient id="dashGrad2" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="#3B82F6" />
        <stop offset="100%" stopColor="#60A5FA" />
      </linearGradient>
      <linearGradient id="dashGrad3" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#FBBF24" />
      </linearGradient>
      <linearGradient id="dashGrad4" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="#EF4444" />
        <stop offset="100%" stopColor="#F87171" />
      </linearGradient>
      <filter id="dashShadow">
        <feDropShadow dx="1" dy="2" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Background */}
    <rect x="5" y="5" width="90" height="90" rx="15" fill="#1E293B" filter="url(#dashShadow)" />
    {/* Bars */}
    <rect x="15" y="55" width="15" height="30" rx="4" fill="url(#dashGrad1)" />
    <rect x="35" y="35" width="15" height="50" rx="4" fill="url(#dashGrad2)" />
    <rect x="55" y="45" width="15" height="40" rx="4" fill="url(#dashGrad3)" />
    <rect x="75" y="25" width="15" height="60" rx="4" fill="url(#dashGrad4)" />
    {/* Line chart */}
    <path d="M15 50 L35 30 L55 40 L75 20" stroke="#3B82F6" strokeWidth="3" fill="none" strokeLinecap="round" />
    <circle cx="15" cy="50" r="4" fill="#3B82F6" />
    <circle cx="35" cy="30" r="4" fill="#3B82F6" />
    <circle cx="55" cy="40" r="4" fill="#3B82F6" />
    <circle cx="75" cy="20" r="4" fill="#3B82F6" />
  </svg>
);

// 👥 HR Icon - People Group
export const HRIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="hrGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#8B5CF6" />
        <stop offset="100%" stopColor="#6366F1" />
      </linearGradient>
      <filter id="hrShadow">
        <feDropShadow dx="1" dy="2" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Center person */}
    <circle cx="50" cy="30" r="14" fill="url(#hrGrad)" filter="url(#hrShadow)" />
    <path d="M30 75 Q30 50 50 50 Q70 50 70 75" fill="url(#hrGrad)" filter="url(#hrShadow)" />
    {/* Left person */}
    <circle cx="22" cy="40" r="10" fill="#A78BFA" opacity="0.8" />
    <path d="M10 70 Q10 52 22 52 Q34 52 34 70" fill="#A78BFA" opacity="0.8" />
    {/* Right person */}
    <circle cx="78" cy="40" r="10" fill="#A78BFA" opacity="0.8" />
    <path d="M66 70 Q66 52 78 52 Q90 52 90 70" fill="#A78BFA" opacity="0.8" />
  </svg>
);

// 👤 Employee Icon
export const EmployeeIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="empGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#06B6D4" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <filter id="empShadow">
        <feDropShadow dx="1" dy="2" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    <circle cx="50" cy="32" r="20" fill="url(#empGrad)" filter="url(#empShadow)" />
    <path d="M20 90 Q20 55 50 55 Q80 55 80 90" fill="url(#empGrad)" filter="url(#empShadow)" />
    {/* Tie */}
    <path d="M50 55 L45 70 L50 90 L55 70 Z" fill="#0E7490" />
  </svg>
);

// ⏰ Attendance Icon - Clock
export const AttendanceIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="clockGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F59E0B" />
        <stop offset="50%" stopColor="#D97706" />
        <stop offset="100%" stopColor="#B45309" />
      </linearGradient>
      <linearGradient id="clockFace" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FFFBEB" />
        <stop offset="100%" stopColor="#FEF3C7" />
      </linearGradient>
      <filter id="clockShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="3" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Clock body */}
    <circle cx="50" cy="50" r="42" fill="url(#clockGrad)" filter="url(#clockShadow)" />
    <circle cx="50" cy="50" r="36" fill="url(#clockFace)" />
    {/* Hour markers */}
    {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map((angle, i) => (
      <line key={i} x1="50" y1="18" x2="50" y2="22" stroke="#B45309" strokeWidth="2"
        transform={`rotate(${angle} 50 50)`} />
    ))}
    {/* Hands */}
    <line x1="50" y1="50" x2="50" y2="28" stroke="#B45309" strokeWidth="4" strokeLinecap="round" />
    <line x1="50" y1="50" x2="68" y2="50" stroke="#D97706" strokeWidth="3" strokeLinecap="round" />
    <circle cx="50" cy="50" r="4" fill="#B45309" />
    {/* Check mark */}
    <circle cx="75" cy="75" r="15" fill="#10B981" />
    <path d="M68 75 L73 80 L83 70" stroke="#FFF" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// 🏖️ Leave Icon - Palm Tree
export const LeaveIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="sandGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#FBBF24" />
        <stop offset="100%" stopColor="#F59E0B" />
      </linearGradient>
      <linearGradient id="palmGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#22C55E" />
        <stop offset="100%" stopColor="#15803D" />
      </linearGradient>
      <linearGradient id="trunkGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#92400E" />
        <stop offset="50%" stopColor="#A16207" />
        <stop offset="100%" stopColor="#78350F" />
      </linearGradient>
    </defs>
    {/* Sun */}
    <circle cx="75" cy="25" r="15" fill="#FCD34D" />
    {/* Palm trunk */}
    <path d="M45 90 Q48 60 50 40" stroke="url(#trunkGrad)" strokeWidth="8" fill="none" strokeLinecap="round" />
    {/* Palm leaves */}
    <path d="M50 40 Q30 25 15 35" stroke="url(#palmGrad)" strokeWidth="6" fill="none" strokeLinecap="round" />
    <path d="M50 40 Q70 20 85 30" stroke="url(#palmGrad)" strokeWidth="6" fill="none" strokeLinecap="round" />
    <path d="M50 40 Q45 15 55 10" stroke="url(#palmGrad)" strokeWidth="6" fill="none" strokeLinecap="round" />
    <path d="M50 40 Q25 35 20 50" stroke="url(#palmGrad)" strokeWidth="5" fill="none" strokeLinecap="round" />
    <path d="M50 40 Q75 35 80 50" stroke="url(#palmGrad)" strokeWidth="5" fill="none" strokeLinecap="round" />
    {/* Sand */}
    <ellipse cx="50" cy="90" rx="40" ry="8" fill="url(#sandGrad)" />
  </svg>
);

// 📋 Duties Icon - Clipboard
export const DutiesIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="clipGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6366F1" />
        <stop offset="100%" stopColor="#4F46E5" />
      </linearGradient>
      <filter id="clipShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Clipboard body */}
    <rect x="15" y="15" width="70" height="80" rx="8" fill="url(#clipGrad)" filter="url(#clipShadow)" />
    {/* Paper */}
    <rect x="22" y="25" width="56" height="65" rx="4" fill="#FFF" />
    {/* Clip */}
    <rect x="35" y="8" width="30" height="18" rx="4" fill="#4338CA" />
    <rect x="40" y="12" width="20" height="10" rx="3" fill="#C7D2FE" />
    {/* Lines */}
    <rect x="30" y="35" width="30" height="4" rx="2" fill="#A5B4FC" />
    <rect x="30" y="47" width="40" height="4" rx="2" fill="#A5B4FC" />
    <rect x="30" y="59" width="35" height="4" rx="2" fill="#A5B4FC" />
    <rect x="30" y="71" width="25" height="4" rx="2" fill="#A5B4FC" />
    {/* Checkmarks */}
    <circle cx="68" cy="37" r="6" fill="#10B981" />
    <path d="M65 37 L67 39 L72 34" stroke="#FFF" strokeWidth="2" fill="none" />
  </svg>
);

// 💰 Salary Icon - Money Bag
export const SalaryIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="bagGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#10B981" />
        <stop offset="50%" stopColor="#059669" />
        <stop offset="100%" stopColor="#047857" />
      </linearGradient>
      <linearGradient id="coinGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FCD34D" />
        <stop offset="50%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#D97706" />
      </linearGradient>
      <filter id="bagShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="3" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Money bag */}
    <path d="M50 15 L40 25 Q20 30 15 55 Q10 80 50 90 Q90 80 85 55 Q80 30 60 25 L50 15" 
      fill="url(#bagGrad)" filter="url(#bagShadow)" />
    {/* Tie */}
    <ellipse cx="50" cy="28" rx="12" ry="5" fill="#047857" />
    {/* Dollar sign */}
    <text x="50" y="65" textAnchor="middle" fill="#FCD34D" fontSize="35" fontWeight="bold">$</text>
    {/* Floating coins */}
    <circle cx="80" cy="30" r="10" fill="url(#coinGrad)" />
    <text x="80" y="35" textAnchor="middle" fill="#92400E" fontSize="12" fontWeight="bold">$</text>
    <circle cx="20" cy="40" r="8" fill="url(#coinGrad)" opacity="0.8" />
  </svg>
);

// 🎁 Bonus Icon - Gift Box
export const BonusIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="giftGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#EC4899" />
        <stop offset="100%" stopColor="#DB2777" />
      </linearGradient>
      <linearGradient id="ribbonGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FCD34D" />
        <stop offset="100%" stopColor="#F59E0B" />
      </linearGradient>
      <filter id="giftShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Box bottom */}
    <rect x="15" y="45" width="70" height="45" rx="6" fill="url(#giftGrad)" filter="url(#giftShadow)" />
    {/* Box lid */}
    <rect x="10" y="35" width="80" height="15" rx="4" fill="#F472B6" filter="url(#giftShadow)" />
    {/* Vertical ribbon */}
    <rect x="45" y="35" width="10" height="55" fill="url(#ribbonGrad)" />
    {/* Horizontal ribbon */}
    <rect x="10" y="55" width="80" height="10" fill="url(#ribbonGrad)" />
    {/* Bow */}
    <ellipse cx="35" cy="30" rx="12" ry="8" fill="url(#ribbonGrad)" />
    <ellipse cx="65" cy="30" rx="12" ry="8" fill="url(#ribbonGrad)" />
    <circle cx="50" cy="32" r="6" fill="#D97706" />
    {/* Sparkles */}
    <path d="M80 15 L82 20 L87 20 L83 24 L85 29 L80 26 L75 29 L77 24 L73 20 L78 20 Z" fill="#FCD34D" />
    <path d="M20 20 L21 23 L24 23 L22 25 L23 28 L20 26 L17 28 L18 25 L16 23 L19 23 Z" fill="#FCD34D" opacity="0.7" />
  </svg>
);

// ⚠️ Warning/Penalty Icon
export const WarningIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="warnGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#FBBF24" />
        <stop offset="100%" stopColor="#F59E0B" />
      </linearGradient>
      <filter id="warnShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="3" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Triangle */}
    <path d="M50 10 L95 85 L5 85 Z" fill="url(#warnGrad)" filter="url(#warnShadow)" />
    <path d="M50 20 L85 78 L15 78 Z" fill="#FFFBEB" />
    {/* Exclamation */}
    <rect x="46" y="35" width="8" height="25" rx="4" fill="#D97706" />
    <circle cx="50" cy="68" r="5" fill="#D97706" />
  </svg>
);

// 📊 Performance/KPI Icon
export const PerformanceIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="perfGrad" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#10B981" />
        <stop offset="50%" stopColor="#3B82F6" />
        <stop offset="100%" stopColor="#8B5CF6" />
      </linearGradient>
      <filter id="perfShadow">
        <feDropShadow dx="1" dy="2" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Background circle */}
    <circle cx="50" cy="50" r="42" fill="#1E293B" filter="url(#perfShadow)" />
    {/* Progress arc */}
    <circle cx="50" cy="50" r="35" fill="none" stroke="#374151" strokeWidth="8" />
    <circle cx="50" cy="50" r="35" fill="none" stroke="url(#perfGrad)" strokeWidth="8" 
      strokeDasharray="176 220" strokeLinecap="round" transform="rotate(-90 50 50)" />
    {/* Percentage */}
    <text x="50" y="55" textAnchor="middle" fill="#FFF" fontSize="20" fontWeight="bold">85%</text>
    {/* Arrow up */}
    <path d="M50 70 L45 78 L50 75 L55 78 Z" fill="#10B981" />
  </svg>
);

// 📄 Contract Icon
export const ContractIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="contractGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#64748B" />
        <stop offset="100%" stopColor="#475569" />
      </linearGradient>
      <filter id="contractShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Paper */}
    <rect x="20" y="10" width="60" height="80" rx="4" fill="url(#contractGrad)" filter="url(#contractShadow)" />
    <rect x="25" y="15" width="50" height="70" rx="2" fill="#FFF" />
    {/* Lines */}
    <rect x="32" y="25" width="35" height="3" rx="1" fill="#CBD5E1" />
    <rect x="32" y="35" width="30" height="3" rx="1" fill="#CBD5E1" />
    <rect x="32" y="45" width="35" height="3" rx="1" fill="#CBD5E1" />
    <rect x="32" y="55" width="25" height="3" rx="1" fill="#CBD5E1" />
    {/* Signature */}
    <path d="M35 72 Q45 65 55 72 Q65 78 70 70" stroke="#1E40AF" strokeWidth="2" fill="none" />
    {/* Seal */}
    <circle cx="65" cy="72" r="8" fill="#DC2626" opacity="0.8" />
  </svg>
);

// 💼 Business Icon
export const BusinessIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="briefGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#78716C" />
        <stop offset="50%" stopColor="#57534E" />
        <stop offset="100%" stopColor="#44403C" />
      </linearGradient>
      <filter id="briefShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="3" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Briefcase body */}
    <rect x="10" y="35" width="80" height="50" rx="8" fill="url(#briefGrad)" filter="url(#briefShadow)" />
    {/* Handle */}
    <path d="M35 35 L35 25 Q35 18 42 18 L58 18 Q65 18 65 25 L65 35" stroke="#44403C" strokeWidth="6" fill="none" />
    {/* Lock */}
    <rect x="43" y="52" width="14" height="12" rx="2" fill="#FCD34D" />
    <circle cx="50" cy="56" r="3" fill="#44403C" />
  </svg>
);

// 📒 Accounts Icon
export const AccountsIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="bookGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#059669" />
        <stop offset="100%" stopColor="#047857" />
      </linearGradient>
      <filter id="bookShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Book cover */}
    <rect x="15" y="10" width="70" height="80" rx="4" fill="url(#bookGrad)" filter="url(#bookShadow)" />
    {/* Pages */}
    <rect x="22" y="15" width="58" height="70" rx="2" fill="#FFF" />
    {/* Spine */}
    <rect x="15" y="10" width="8" height="80" rx="2" fill="#047857" />
    {/* Calculator display */}
    <rect x="30" y="25" width="40" height="15" rx="2" fill="#1E293B" />
    <text x="65" y="37" textAnchor="end" fill="#10B981" fontSize="12" fontFamily="monospace">1,250.00</text>
    {/* Calculator buttons */}
    {[0,1,2].map(row => [0,1,2,3].map(col => (
      <rect key={`${row}-${col}`} x={32 + col*10} y={45 + row*12} width="8" height="8" rx="1" fill="#E2E8F0" />
    )))}
  </svg>
);

// 📈 Reports Icon
export const ReportsIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="reportGrad" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#3B82F6" />
        <stop offset="100%" stopColor="#60A5FA" />
      </linearGradient>
      <filter id="reportShadow">
        <feDropShadow dx="1" dy="2" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Background */}
    <rect x="10" y="10" width="80" height="80" rx="10" fill="#1E293B" filter="url(#reportShadow)" />
    {/* Grid lines */}
    <line x1="20" y1="75" x2="80" y2="75" stroke="#374151" strokeWidth="1" />
    <line x1="20" y1="55" x2="80" y2="55" stroke="#374151" strokeWidth="1" strokeDasharray="4" />
    <line x1="20" y1="35" x2="80" y2="35" stroke="#374151" strokeWidth="1" strokeDasharray="4" />
    {/* Chart line */}
    <path d="M20 65 L35 50 L50 58 L65 35 L80 25" stroke="url(#reportGrad)" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    {/* Dots */}
    <circle cx="20" cy="65" r="4" fill="#3B82F6" />
    <circle cx="35" cy="50" r="4" fill="#3B82F6" />
    <circle cx="50" cy="58" r="4" fill="#3B82F6" />
    <circle cx="65" cy="35" r="4" fill="#3B82F6" />
    <circle cx="80" cy="25" r="4" fill="#3B82F6" />
    {/* Arrow up */}
    <path d="M75 15 L80 25 L85 15" fill="none" stroke="#10B981" strokeWidth="2" />
  </svg>
);

// ⚙️ Settings Icon - Gear
export const SettingsIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="gearGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6B7280" />
        <stop offset="50%" stopColor="#4B5563" />
        <stop offset="100%" stopColor="#374151" />
      </linearGradient>
      <filter id="gearShadow">
        <feDropShadow dx="1" dy="2" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Gear */}
    <path d="M50 10 L55 10 L57 20 L65 22 L72 14 L78 20 L70 27 L73 35 L83 37 L83 43 L73 45 L70 53 L78 60 L72 66 L65 58 L57 60 L55 70 L45 70 L43 60 L35 58 L28 66 L22 60 L30 53 L27 45 L17 43 L17 37 L27 35 L30 27 L22 20 L28 14 L35 22 L43 20 L45 10 Z" 
      fill="url(#gearGrad)" filter="url(#gearShadow)" />
    <circle cx="50" cy="40" r="12" fill="#1E293B" />
    {/* Inner gear */}
    <circle cx="50" cy="40" r="8" fill="url(#gearGrad)" />
    <circle cx="50" cy="40" r="4" fill="#1E293B" />
  </svg>
);

// 🏢 Department Icon
export const DepartmentIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="buildGrad" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="#6366F1" />
        <stop offset="100%" stopColor="#818CF8" />
      </linearGradient>
      <filter id="buildShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Main building */}
    <rect x="25" y="30" width="50" height="60" rx="4" fill="url(#buildGrad)" filter="url(#buildShadow)" />
    {/* Roof */}
    <path d="M20 32 L50 10 L80 32 Z" fill="#4F46E5" />
    {/* Windows */}
    {[0,1,2].map(row => [0,1].map(col => (
      <rect key={`w${row}-${col}`} x={33 + col*22} y={40 + row*18} width="12" height="10" rx="1" fill="#C7D2FE" />
    )))}
    {/* Door */}
    <rect x="42" y="72" width="16" height="18" rx="2" fill="#312E81" />
    <circle cx="54" cy="82" r="2" fill="#FCD34D" />
  </svg>
);

// 🏪 Branch Icon
export const BranchIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="storeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#D97706" />
      </linearGradient>
      <filter id="storeShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Store body */}
    <rect x="15" y="40" width="70" height="50" rx="4" fill="url(#storeGrad)" filter="url(#storeShadow)" />
    {/* Awning */}
    <path d="M10 42 Q25 25 50 42 Q75 25 90 42 L90 50 L10 50 Z" fill="#DC2626" />
    <path d="M10 42 Q25 55 50 42 Q75 55 90 42" stroke="#B91C1C" strokeWidth="2" fill="none" />
    {/* Sign */}
    <rect x="30" y="20" width="40" height="15" rx="3" fill="#1E293B" />
    <text x="50" y="31" textAnchor="middle" fill="#FCD34D" fontSize="10" fontWeight="bold">SHOP</text>
    {/* Door */}
    <rect x="40" y="60" width="20" height="30" rx="2" fill="#78350F" />
    <circle cx="55" cy="75" r="2" fill="#FCD34D" />
    {/* Window */}
    <rect x="20" y="55" width="15" height="15" rx="2" fill="#BFDBFE" />
    <rect x="65" y="55" width="15" height="15" rx="2" fill="#BFDBFE" />
  </svg>
);

// 🚗 Vehicle Icon
export const VehicleIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="carGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3B82F6" />
        <stop offset="100%" stopColor="#1D4ED8" />
      </linearGradient>
      <filter id="carShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="3" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Car body */}
    <path d="M15 55 L20 40 L35 35 L65 35 L80 40 L85 55 L85 65 L15 65 Z" fill="url(#carGrad)" filter="url(#carShadow)" />
    {/* Roof */}
    <path d="M30 35 L35 22 L65 22 L70 35" fill="#60A5FA" />
    {/* Windows */}
    <path d="M33 33 L36 24 L48 24 L48 33 Z" fill="#BFDBFE" />
    <path d="M52 33 L52 24 L64 24 L67 33 Z" fill="#BFDBFE" />
    {/* Wheels */}
    <circle cx="28" cy="65" r="10" fill="#1E293B" />
    <circle cx="28" cy="65" r="6" fill="#6B7280" />
    <circle cx="72" cy="65" r="10" fill="#1E293B" />
    <circle cx="72" cy="65" r="6" fill="#6B7280" />
    {/* Lights */}
    <rect x="15" y="48" width="6" height="4" rx="1" fill="#FCD34D" />
    <rect x="79" y="48" width="6" height="4" rx="1" fill="#FCD34D" />
    {/* Bumper */}
    <rect x="12" y="62" width="76" height="5" rx="2" fill="#374151" />
  </svg>
);

// 🔐 Permissions Icon
export const PermissionsIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="lockGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FCD34D" />
        <stop offset="50%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#D97706" />
      </linearGradient>
      <filter id="lockShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Lock body */}
    <rect x="25" y="45" width="50" height="40" rx="8" fill="url(#lockGrad)" filter="url(#lockShadow)" />
    {/* Shackle */}
    <path d="M32 45 L32 32 Q32 15 50 15 Q68 15 68 32 L68 45" stroke="#D97706" strokeWidth="8" fill="none" strokeLinecap="round" />
    {/* Keyhole */}
    <circle cx="50" cy="60" r="8" fill="#78350F" />
    <rect x="47" y="60" width="6" height="15" rx="2" fill="#78350F" />
    {/* Shield */}
    <path d="M75 20 L90 25 L90 40 Q90 55 75 65 Q60 55 60 40 L60 25 Z" fill="#10B981" />
    <path d="M70 40 L73 43 L82 34" stroke="#FFF" strokeWidth="3" fill="none" strokeLinecap="round" />
  </svg>
);

// 📦 Inventory Icon
export const InventoryIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="boxGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#B45309" />
      </linearGradient>
      <filter id="boxShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Back boxes */}
    <rect x="55" y="15" width="35" height="35" rx="4" fill="#D97706" opacity="0.6" />
    <rect x="10" y="25" width="35" height="35" rx="4" fill="#D97706" opacity="0.8" />
    {/* Front box */}
    <rect x="30" y="45" width="50" height="45" rx="4" fill="url(#boxGrad)" filter="url(#boxShadow)" />
    {/* Box flaps */}
    <path d="M30 50 L55 40 L80 50" fill="#F59E0B" />
    {/* Box lines */}
    <line x1="55" y1="45" x2="55" y2="90" stroke="#92400E" strokeWidth="2" />
    <line x1="30" y1="67" x2="80" y2="67" stroke="#92400E" strokeWidth="2" />
    {/* Barcode */}
    <rect x="60" y="72" width="2" height="10" fill="#1E293B" />
    <rect x="64" y="72" width="1" height="10" fill="#1E293B" />
    <rect x="67" y="72" width="3" height="10" fill="#1E293B" />
    <rect x="72" y="72" width="1" height="10" fill="#1E293B" />
  </svg>
);

// 💵 My Salary Icon
export const MySalaryIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="billGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#22C55E" />
        <stop offset="50%" stopColor="#16A34A" />
        <stop offset="100%" stopColor="#15803D" />
      </linearGradient>
      <filter id="billShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Multiple bills stacked */}
    <rect x="8" y="28" width="70" height="40" rx="4" fill="#86EFAC" transform="rotate(-5)" />
    <rect x="12" y="32" width="70" height="40" rx="4" fill="#4ADE80" />
    <rect x="15" y="35" width="70" height="40" rx="4" fill="url(#billGrad)" filter="url(#billShadow)" />
    {/* Dollar sign */}
    <circle cx="50" cy="55" r="15" fill="#15803D" />
    <text x="50" y="62" textAnchor="middle" fill="#FFF" fontSize="20" fontWeight="bold">$</text>
    {/* Decorative corners */}
    <circle cx="25" cy="45" r="5" fill="#15803D" opacity="0.5" />
    <circle cx="75" cy="45" r="5" fill="#15803D" opacity="0.5" />
    <circle cx="25" cy="65" r="5" fill="#15803D" opacity="0.5" />
    <circle cx="75" cy="65" r="5" fill="#15803D" opacity="0.5" />
    {/* Sparkle */}
    <path d="M82 20 L84 25 L89 25 L85 29 L87 34 L82 31 L77 34 L79 29 L75 25 L80 25 Z" fill="#FCD34D" />
  </svg>
);

// 📋 Terms Icon
export const TermsIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="termsGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#8B5CF6" />
        <stop offset="100%" stopColor="#7C3AED" />
      </linearGradient>
      <filter id="termsShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Document */}
    <rect x="20" y="10" width="60" height="80" rx="4" fill="url(#termsGrad)" filter="url(#termsShadow)" />
    <rect x="25" y="15" width="50" height="70" rx="2" fill="#FFF" />
    {/* Header line */}
    <rect x="32" y="22" width="36" height="4" rx="2" fill="#8B5CF6" />
    {/* Text lines */}
    <rect x="32" y="32" width="36" height="2" rx="1" fill="#C4B5FD" />
    <rect x="32" y="38" width="30" height="2" rx="1" fill="#C4B5FD" />
    <rect x="32" y="44" width="34" height="2" rx="1" fill="#C4B5FD" />
    <rect x="32" y="50" width="28" height="2" rx="1" fill="#C4B5FD" />
    <rect x="32" y="56" width="32" height="2" rx="1" fill="#C4B5FD" />
    {/* Checkmark seal */}
    <circle cx="65" cy="72" r="10" fill="#10B981" />
    <path d="M60 72 L63 75 L71 67" stroke="#FFF" strokeWidth="2" fill="none" strokeLinecap="round" />
    {/* Signature line */}
    <line x1="32" y1="75" x2="52" y2="75" stroke="#8B5CF6" strokeWidth="1" strokeDasharray="2" />
  </svg>
);

// 📊 KPI/Analytics Icon
export const KPIIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="kpiGrad" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#8B5CF6" />
        <stop offset="50%" stopColor="#A855F7" />
        <stop offset="100%" stopColor="#C084FC" />
      </linearGradient>
      <filter id="kpiShadow">
        <feDropShadow dx="1" dy="2" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    <rect x="10" y="10" width="80" height="80" rx="12" fill="#1E293B" filter="url(#kpiShadow)" />
    {/* Speedometer arc */}
    <path d="M25 60 A25 25 0 0 1 75 60" fill="none" stroke="#374151" strokeWidth="8" strokeLinecap="round" />
    <path d="M25 60 A25 25 0 0 1 60 38" fill="none" stroke="url(#kpiGrad)" strokeWidth="8" strokeLinecap="round" />
    {/* Needle */}
    <line x1="50" y1="60" x2="58" y2="42" stroke="#C084FC" strokeWidth="4" strokeLinecap="round" />
    <circle cx="50" cy="60" r="6" fill="#8B5CF6" />
    {/* Value */}
    <text x="50" y="82" textAnchor="middle" fill="#FFF" fontSize="14" fontWeight="bold">92%</text>
  </svg>
);

// 🔔 Notification Icon
export const NotificationIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="bellGoldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FCD34D" />
        <stop offset="50%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#D97706" />
      </linearGradient>
      <filter id="bellShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Bell body */}
    <path d="M50 15 C30 15 20 30 20 50 L20 60 C20 63 18 66 15 68 L15 72 L85 72 L85 68 C82 66 80 63 80 60 L80 50 C80 30 70 15 50 15 Z" 
      fill="url(#bellGoldGrad)" filter="url(#bellShadow)" />
    {/* Bell clapper */}
    <ellipse cx="50" cy="80" rx="10" ry="5" fill="#D97706" />
    {/* Top ring */}
    <circle cx="50" cy="12" r="5" fill="#F59E0B" />
    {/* Notification dot */}
    <circle cx="72" cy="28" r="12" fill="#EF4444" />
    <text x="72" y="33" textAnchor="middle" fill="#FFF" fontSize="14" fontWeight="bold">3</text>
  </svg>
);

// ⚙️ Enhanced Settings Icon
export const SettingsIconModern = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="settingsGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#94A3B8" />
        <stop offset="50%" stopColor="#64748B" />
        <stop offset="100%" stopColor="#475569" />
      </linearGradient>
      <filter id="settingsShadow">
        <feDropShadow dx="1" dy="2" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Outer gear */}
    <path d="M50 8 L54 8 L57 18 L66 21 L74 12 L80 18 L71 26 L74 35 L84 38 L84 44 L74 47 L71 56 L80 64 L74 70 L66 61 L57 64 L54 74 L46 74 L43 64 L34 61 L26 70 L20 64 L29 56 L26 47 L16 44 L16 38 L26 35 L29 26 L20 18 L26 12 L34 21 L43 18 L46 8 Z" 
      fill="url(#settingsGrad)" filter="url(#settingsShadow)" />
    <circle cx="50" cy="41" r="16" fill="#1E293B" />
    <circle cx="50" cy="41" r="10" fill="url(#settingsGrad)" />
    <circle cx="50" cy="41" r="5" fill="#1E293B" />
    {/* Secondary small gear */}
    <path d="M75 70 L77 70 L78 75 L82 76 L85 73 L88 76 L85 80 L86 84 L91 85 L91 88 L86 89 L85 93 L88 97 L85 100 L81 97 L77 98 L76 103 L73 103 L72 98 L68 97 L65 100 L62 97 L65 93 L64 89 L59 88 L59 85 L64 84 L65 80 L62 76 L65 73 L69 76 L73 75 L74 70 Z" 
      fill="#CBD5E1" transform="scale(0.7) translate(15, 15)" />
  </svg>
);

// 👤 User Profile Icon
export const UserIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="userGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3B82F6" />
        <stop offset="100%" stopColor="#1D4ED8" />
      </linearGradient>
      <filter id="userShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Background circle */}
    <circle cx="50" cy="50" r="45" fill="#EFF6FF" filter="url(#userShadow)" />
    {/* Head */}
    <circle cx="50" cy="35" r="18" fill="url(#userGrad)" />
    {/* Body */}
    <path d="M22 85 Q22 58 50 58 Q78 58 78 85" fill="url(#userGrad)" />
  </svg>
);

// ✅ Checkmark/Success Icon
export const CheckIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="checkGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#22C55E" />
        <stop offset="100%" stopColor="#16A34A" />
      </linearGradient>
      <filter id="checkShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="3" floodOpacity="0.3"/>
      </filter>
    </defs>
    <circle cx="50" cy="50" r="42" fill="url(#checkGrad)" filter="url(#checkShadow)" />
    <path d="M30 52 L45 67 L72 35" stroke="#FFF" strokeWidth="8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// ⏳ Pending/Clock Icon
export const PendingIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="pendingGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#D97706" />
      </linearGradient>
      <filter id="pendingShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    <circle cx="50" cy="50" r="42" fill="url(#pendingGrad)" filter="url(#pendingShadow)" />
    {/* Hourglass */}
    <path d="M35 25 L65 25 L58 45 L50 50 L42 45 L35 25 Z" fill="#FEF3C7" />
    <path d="M35 75 L65 75 L58 55 L50 50 L42 55 L35 75 Z" fill="#FEF3C7" />
    <path d="M42 70 L58 70 L52 58 L50 55 L48 58 L42 70 Z" fill="#D97706" />
  </svg>
);

// 🏥 Medical/Hospital Icon
export const MedicalIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="medGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#EF4444" />
        <stop offset="100%" stopColor="#DC2626" />
      </linearGradient>
      <filter id="medShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Cross background */}
    <rect x="15" y="15" width="70" height="70" rx="12" fill="url(#medGrad)" filter="url(#medShadow)" />
    {/* Cross */}
    <rect x="42" y="25" width="16" height="50" rx="3" fill="#FFF" />
    <rect x="25" y="42" width="50" height="16" rx="3" fill="#FFF" />
  </svg>
);

// 🚨 Emergency Icon
export const EmergencyIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="emergGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F97316" />
        <stop offset="100%" stopColor="#EA580C" />
      </linearGradient>
      <filter id="emergShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Siren base */}
    <ellipse cx="50" cy="75" rx="35" ry="12" fill="#7C2D12" />
    <rect x="20" y="50" width="60" height="28" rx="4" fill="url(#emergGrad)" filter="url(#emergShadow)" />
    {/* Light dome */}
    <ellipse cx="50" cy="50" rx="25" ry="18" fill="#FED7AA" />
    <ellipse cx="50" cy="48" rx="18" ry="12" fill="#F97316">
      <animate attributeName="opacity" values="1;0.5;1" dur="0.5s" repeatCount="indefinite" />
    </ellipse>
    {/* Sound waves */}
    <path d="M20 35 Q10 45 20 55" fill="none" stroke="#F97316" strokeWidth="3" opacity="0.6">
      <animate attributeName="opacity" values="0.6;0.2;0.6" dur="0.5s" repeatCount="indefinite" />
    </path>
    <path d="M80 35 Q90 45 80 55" fill="none" stroke="#F97316" strokeWidth="3" opacity="0.6">
      <animate attributeName="opacity" values="0.6;0.2;0.6" dur="0.5s" repeatCount="indefinite" />
    </path>
  </svg>
);

// 📍 Location Pin Icon
export const LocationIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="locGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#EF4444" />
        <stop offset="100%" stopColor="#B91C1C" />
      </linearGradient>
      <filter id="locShadow">
        <feDropShadow dx="2" dy="3" stdDeviation="3" floodOpacity="0.3"/>
      </filter>
    </defs>
    {/* Pin */}
    <path d="M50 90 C50 90 20 55 20 38 C20 22 33 10 50 10 C67 10 80 22 80 38 C80 55 50 90 50 90 Z" 
      fill="url(#locGrad)" filter="url(#locShadow)" />
    {/* Inner circle */}
    <circle cx="50" cy="38" r="15" fill="#FFF" />
    <circle cx="50" cy="38" r="8" fill="#EF4444" />
  </svg>
);

// 📊 Stats Card Icon
export const StatsIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100">
    <defs>
      <linearGradient id="statsGrad1" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="#06B6D4" />
        <stop offset="100%" stopColor="#22D3EE" />
      </linearGradient>
      <linearGradient id="statsGrad2" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="#8B5CF6" />
        <stop offset="100%" stopColor="#A78BFA" />
      </linearGradient>
      <linearGradient id="statsGrad3" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="#10B981" />
        <stop offset="100%" stopColor="#34D399" />
      </linearGradient>
      <filter id="statsShadow">
        <feDropShadow dx="1" dy="2" stdDeviation="2" floodOpacity="0.2"/>
      </filter>
    </defs>
    {/* Background */}
    <rect x="5" y="5" width="90" height="90" rx="15" fill="#1E293B" filter="url(#statsShadow)" />
    {/* Bars */}
    <rect x="15" y="50" width="18" height="35" rx="4" fill="url(#statsGrad1)" />
    <rect x="41" y="30" width="18" height="55" rx="4" fill="url(#statsGrad2)" />
    <rect x="67" y="20" width="18" height="65" rx="4" fill="url(#statsGrad3)" />
    {/* Trend line */}
    <path d="M24 45 L50 25 L76 15" stroke="#FCD34D" strokeWidth="3" fill="none" strokeLinecap="round" />
  </svg>
);

// Icon mapping
export const ModernIcons = {
  'dashboard': DashboardIcon,
  'hr': HRIcon,
  'employee': EmployeeIcon,
  'attendance': AttendanceIcon,
  'leave': LeaveIcon,
  'duties': DutiesIcon,
  'salary': SalaryIcon,
  'bonus': BonusIcon,
  'warning': WarningIcon,
  'performance': PerformanceIcon,
  'contract': ContractIcon,
  'business': BusinessIcon,
  'accounts': AccountsIcon,
  'reports': ReportsIcon,
  'settings': SettingsIcon,
  'settings-modern': SettingsIconModern,
  'department': DepartmentIcon,
  'branch': BranchIcon,
  'vehicle': VehicleIcon,
  'permissions': PermissionsIcon,
  'inventory': InventoryIcon,
  'my-salary': MySalaryIcon,
  'terms': TermsIcon,
  'kpi': KPIIcon,
  'notification': NotificationIcon,
  'user': UserIcon,
  'check': CheckIcon,
  'pending': PendingIcon,
  'medical': MedicalIcon,
  'emergency': EmergencyIcon,
  'location': LocationIcon,
  'stats': StatsIcon,
};

// Helper function to render icon
export const renderModernIcon = (iconKey, size = 24) => {
  const iconMap = {
    '📊': DashboardIcon,
    '👥': HRIcon,
    '👤': EmployeeIcon,
    '⏰': AttendanceIcon,
    '🏖️': LeaveIcon,
    '📋': DutiesIcon,
    '💰': SalaryIcon,
    '🎁': BonusIcon,
    '⚠️': WarningIcon,
    '📈': ReportsIcon,
    '📄': ContractIcon,
    '💼': BusinessIcon,
    '📒': AccountsIcon,
    '⚙️': SettingsIcon,
    '🏢': DepartmentIcon,
    '🏪': BranchIcon,
    '🚗': VehicleIcon,
    '🔐': PermissionsIcon,
    '📦': InventoryIcon,
    '💵': MySalaryIcon,
    '🏥': MedicalIcon,
    '🚨': EmergencyIcon,
    '📍': LocationIcon,
    '✅': CheckIcon,
    '⏳': PendingIcon,
  };
  
  const IconComponent = iconMap[iconKey] || ModernIcons[iconKey];
  if (IconComponent) {
    return <IconComponent size={size} />;
  }
  return null;
};

export default ModernIcons;
